import {GPTypeStructure} from "./gp-typestructure";
import {GP3DItemRenderer} from "./gp-3ditemrenderer";

export class GPTypeStructure3d extends GPTypeStructure {
    constructor(gst) {
        super(gst);

        this.typeName = "GPTypeStructure3d"
        this.initrot = gst["initrot"];
        this.model3d = true;
        this.outline = gst["outline"];
    }

    async staticGetPathForImage () {
        let modelPath = GPSettings.structuresAddr(this, false, "b") +'3d/'+this.image+'.glb';
        let res = await GP3DItemRenderer.renderObjectToCanvas(modelPath, parseFloat(this.initrot), parseFloat(this.height), this.outline, 1);
        return res['img'].toDataURL('image/webp')
    }

}